import { ECMProductTypeDto } from '@core/services/dto/ecm-product-type.dto';

export class ECMProductTypeModel {
  value: string;

  constructor(dto: ECMProductTypeDto) {
    this.value = dto.productType;
  }
}
